import React from 'react';
import './skeleton-loading.less';

function SkeletonHidden({loading, children}) {
    if (!loading) {
        return children;
    }

    let SKELETON_CLASS = 'skeleton-hidden';
    return React.Children.map(children, (child) => {
        let className = child.props.className || '';
        className = (className.length ? `${className} ${SKELETON_CLASS}` : SKELETON_CLASS);
        return React.cloneElement(child, {className});
    });
}

export default SkeletonHidden;


// WEBPACK FOOTER //
// ./src/universal/abacus/skeleton-abc/skeleton-hidden.js